<template>
  <div class="merge">
    <el-dialog
      :title="$t('supplyChain.dialog.merge')"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
      :before-close="handleClose"
    >
      <div class="container">
        <el-form
          inline
          :model="mergeData"
          :rules="mergeDataRules"
          ref="mergeData"
          label-width="60px"
        >
          <el-form-item :label="$t('supplyChain.label.sourceSupplieCode')" prop="sourceSupplieCode">
            <el-input v-model="mergeData.sourceSupplieCode"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('supplyChain.label.targetSupplierCode')"
            prop="targetSupplierCode"
          >
            <el-input v-model="mergeData.targetSupplierCode"></el-input>
          </el-form-item>
        </el-form>
        <el-progress :percentage="progress" :status="status"></el-progress>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('supplyChain.button.cancel') }}</el-button>
        <el-button type="primary" @click="handleSure">{{
          $t('supplyChain.button.sure')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import API from '@/api/masterData/supplyChain.js';
  export default {
    name: 'merge',
    data() {
      return {
        dialogVisible: false,
        progress: 0,
        status: null,
        propsData: null, // 父组件传递过来的数据
        mergeData: {
          sourceSupplieCode: '', // 原编码
          targetSupplierCode: '', // 新编码
        },
        mergeDataRules: {
          // 校验规则
          sourceSupplieCode: [
            { required: true, message: this.$t('supplyChain.placeholder.input'), trigger: 'blur' },
          ],
          targetSupplierCode: [
            { required: true, message: this.$t('supplyChain.placeholder.input'), trigger: 'blur' },
          ],
        },
      };
    },
    methods: {
      openDialog(data) {
        this.progress = 0;
        this.status = null;
        this.dialogVisible = true;
        this.dialogVisible = true;
        this.propsData = data;
        this.mergeData.sourceSupplieCode = this.propsData.supplierCode;
      },
      // 确定
      handleSure() {
        this.$refs.mergeData.validate((valid) => {
          if (valid) {
            this.$axios.get(API.MERGE_SUPPLIER, this.mergeData).then((res) => {
              if (res.data.code === 0) {
                this.progress = 100;
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                this.handleClose();
                this.$emit('getData');
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
                this.status = 'exception';
              }
            });
          }
        });
      },
      handleClose() {
        this.dialogVisible = false;
        this.$refs.mergeData.resetFields();
      },
    },
  };
</script>

<style scoped>
  .merge .container {
    text-align: center;
  }
</style>
